(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("stream-chat"), require("@bizzabo/instana-api"), require("@bizzabo/entities"), require("stream-chat-react"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , ], factory);
	else if(typeof exports === 'object')
		exports["bizzaboChatCore"] = factory(require("react"), require("stream-chat"), require("@bizzabo/instana-api"), require("@bizzabo/entities"), require("stream-chat-react"));
	else
		root["bizzaboChatCore"] = factory(root[undefined], root[undefined], root[undefined], root["bizzaboEntities"], root[undefined]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5225__, __WEBPACK_EXTERNAL_MODULE__3506__, __WEBPACK_EXTERNAL_MODULE__6788__, __WEBPACK_EXTERNAL_MODULE__3299__, __WEBPACK_EXTERNAL_MODULE__7185__) => {
return 